import { apiClient } from '@/api/client'
import { rawClient } from '@/api/rawClient'
import type { LoginPayload, TokenResponse, User } from '@/features/auth/types'

export const authApi = {
  async login({ email, password }: LoginPayload): Promise<TokenResponse> {
    const form = new URLSearchParams()
    form.set('username', email)
    form.set('password', password)

    const { data } = await rawClient.post<TokenResponse>('/auth/login', form, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    return data
  },

  async refresh(refreshToken: string): Promise<TokenResponse> {
    const { data } = await rawClient.post<TokenResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    })
    return data
  },

  async logout(refreshToken: string, everywhere = false): Promise<void> {
    await apiClient.post('/auth/logout', { refresh_token: refreshToken, everywhere })
  },

  async me(): Promise<User> {
    const { data } = await apiClient.get<User>('/auth/me')
    return data
  },

  // PC-FINAL-3: sin autenticar (como login/refresh) -- rawClient.
  async requestPasswordReset(email: string): Promise<{ message: string }> {
    const { data } = await rawClient.post<{ message: string }>(
      '/auth/password-reset/request',
      { email },
    )
    return data
  },

  async confirmPasswordReset(token: string, newPassword: string): Promise<{ message: string }> {
    const { data } = await rawClient.post<{ message: string }>(
      '/auth/password-reset/confirm',
      { token, new_password: newPassword },
    )
    return data
  },
}
